import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteRoomType, ApiGetRoom, ApiGetRoomList, ApiGetRoomTypeList, ApiInsertRoom, ApiUpdateRoom } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function RoomService() {
    const { showFail } = useModal()

    const { fetch: apiGetRoomList } = useFetch(ApiGetRoomList)
    const { fetch: apiDeleteRoom } = useFetch(ApiDeleteRoomType)
    const { fetch: apiInsertRoom } = useFetch(ApiInsertRoom)
    const { fetch: apiUpdateRoom } = useFetch(ApiUpdateRoom)
    const { fetch: apiGetRoomById } = useFetch(ApiGetRoom)
    const { fetch: apiGetRoomTypeList } = useFetch(ApiGetRoomTypeList)
 
    const fetchCreateRoom = async (roomNumber, roomTypeId, roomStatus) => {
        const res = await apiInsertRoom({
            data: {
                roomNumber,
                roomTypeId,
                roomStatus
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateRoom = async (roomId, roomNumber, roomTypeId, roomStatus) => {
        const res = await apiUpdateRoom({
            data: {
                roomId,
                roomNumber,
                roomTypeId,
                roomStatus
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteRoom = async (roomId) => {
        const res = await apiDeleteRoom({
            data: {
                roomId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchRoomById = async (roomId) => {
        const res = await apiGetRoomById({
            data: {
                roomId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchRoomTypeList = async (roomTypeName, pageSize, pageIndex) => {
        const res = await apiGetRoomTypeList({
            data: {
                roomTypeName,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchRoomList = async (roomNumber, roomTypeId, roomStatus, pageSize, pageIndex) => {
        const res = await apiGetRoomList({
            data: {
                roomNumber,
                roomTypeId,
                roomStatus,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCreateRoom,
        fetchUpdateRoom,
        fetchDeleteRoom,
        fetchRoomById,
        fetchRoomTypeList,
        fetchRoomList
    }
}